<div class='depart-body flexColumn'>
  <!--  顶部title和创建按钮-->
  <div class='top-tool-box flexRow'>
    <div class='tool-title'>部门设置</div>
    <div class='flexFull'></div>
    <div class='add-depart-link my-link flexRow clickEle' (click)='createDepartFun()' *ngIf='showCreate'>
      <i nz-icon nzIconfont='icon_add' class='text-standard'></i>
      <div>{{ createText }}</div>
    </div>
  </div>
  <!--  search-->
  <div class='search-box'>
    <nz-input-group [nzSuffix]='search_clear' [nzPrefix]='searchTpl'>
      <input type='text' nz-input [(ngModel)]='searchKey' placeholder='搜索部门名称' (keydown.enter)='$event.target.blur()'
             (blur)='searchChange($event)' />
    </nz-input-group>
    <ng-template #searchTpl>
      <i nz-icon nzIconfont='icon_search' class='clickEle text-gray1' (click)='dealOrgan()'></i>
    </ng-template>
    <ng-template #search_clear>
      <i nz-icon class='ant-input-clear-icon' nzTheme='fill' nzType='close-circle' *ngIf='searchKey'
         (click)="cancelSearch()"></i>
    </ng-template>
  </div>
  <!--  list列表-->
  <!--  当类型不是机构时-->
  <div class='depart-list flexFull' *ngIf='organ_type != 1'>
    <nz-tree
      #nzTreeComponent
      (nzSearchValueChange)='nzEvent($event)'
      [nzHideUnMatched]='true'
      [nzData]='listOfData'
      (nzClick)='nzClick($event)'
      [nzTreeTemplate]='organ_tpl'
      [nzBlockNode]='true'
      [nzSearchValue]='searchKey'
      [nzVirtualMaxBufferPx]='500'
      [nzVirtualMinBufferPx]='200'
      [nzSelectedKeys]='selectKey'
      [nzExpandedKeys]='expandedKeys'
      [nzVirtualHeight]='virtualHeight'
    >
      <ng-template #organ_tpl let-node>
        <div class='default-div flexRow' [ngClass]="{'text-gray1':node.origin['status']==3}">
          <div class='text-nowrap'>
            <i nz-icon nzIconfont='icon_zu' class='organ-type-icon'
               *ngIf='node.level!=0'></i>
            <i nz-icon nzIconfont='icon_jiagou' class='organ-type-icon'
               *ngIf='node.level==0'></i>
            {{ node.title }}<span *ngIf="node.origin['status']==3">(已冻结)</span>
          </div>
          <div class='flexFull'></div>
          <div nz-dropdown [nzDropdownMenu]='menu' nzTrigger='hover' nzPlacement='bottomCenter'>
            <i nz-icon nzIconfont='icon_more'></i>
            <nz-dropdown-menu #menu='nzDropdownMenu'>
              <ul nz-menu nzSelectable>
                <ng-container *ngFor='let menu of dropdownMenu[organ_type]'>
                  <li
                    nz-menu-item
                    class='flexRow text-default bg-transparency'
                    (click)='operation(menu, node)'
                    *ngIf="!(menu['target']!=='add' && node.origin['isCompany'])"
                  >
                    <i nz-icon nzIconfont="{{ menu['icon'] }}" *ngIf="menu['icon'] != undefined"></i>
                    <div>{{ menu['title'] }}</div>
                  </li>
                </ng-container>

                <li
                  nz-menu-item
                  class='flexRow text-default bg-transparency'
                  (click)="operation({ target: 'freeze', type: node.origin['type'] }, node)"
                  [nzDisabled]="node.origin['organ_peoples'] != 0"
                  *ngIf="!node.origin['isCompany']"
                >
                  <i nz-icon nzIconfont='icon_freeze' *ngIf="node.origin['status'] == 2"></i>
                  <i nz-icon nzIconfont='icon_unfreeze' *ngIf="node.origin['status'] == 3"></i>
                  <div>{{ node.origin['status'] == 2 ? '冻结' : '启用' }}</div>
                </li>
              </ul>
            </nz-dropdown-menu>
          </div>
        </div>
      </ng-template>
    </nz-tree>
  </div>
  <!--当组织类型是机构时-->
  <div class='depart-list flexFull' *ngIf='organ_type == 1'>
    <nz-tree
      #nzTreeComponent
      (nzSearchValueChange)='nzEvent($event)'
      [nzHideUnMatched]='true'
      [nzData]='listOfData'
      (nzClick)='nzClick($event)'
      [nzTreeTemplate]='organ_tpl'
      [nzBlockNode]='true'
      [nzSearchValue]='searchKey'
      [nzVirtualMaxBufferPx]='500'
      [nzVirtualMinBufferPx]='200'
      [nzSelectedKeys]='selectKey'
      [nzExpandedKeys]='expandedKeys'
      [nzVirtualHeight]='virtualHeight'
    >
      <ng-template #organ_tpl let-node>
        <div class='default-div flexRow' [ngClass]="{'text-gray1':node.origin['status']==3}">
          <div class='text-nowrap'>
            <i nz-icon nzIconfont='icon_zu' class='organ-type-icon'
               *ngIf="node.origin['organ_type_extra']==1 || node.origin['organ_type_extra']==4"></i>
            <i nz-icon nzIconfont='icon_pianqu' class='organ-type-icon' *ngIf="node.origin['organ_type_extra']==2 "></i>
            <i nz-icon nzIconfont='icon_arrive' class='organ-type-icon' *ngIf="node.origin['organ_type_extra']==3"></i>
            {{ node.title }}<span *ngIf="node.origin['status']==3">(已冻结)</span>
          </div>
          <div class='flexFull'></div>
          <div nz-dropdown [nzDropdownMenu]='menu' nzTrigger='hover' nzPlacement='bottomCenter'>
            <i nz-icon nzIconfont='icon_more'></i>
            <nz-dropdown-menu #menu='nzDropdownMenu'>
              <ul nz-menu nzSelectable>
                <li
                  nz-menu-item
                  *ngFor="let menu of dropdownMenu[organ_type][node.origin['type']]"
                  class='flexRow text-default bg-transparency'
                  (click)='operation(menu, node)'
                >
                  <i nz-icon nzIconfont="{{ menu['icon'] }}" *ngIf="menu['icon'] != undefined"></i>
                  <div>{{ menu['title'] }}</div>
                </li>
                <li
                  nz-menu-item
                  class='flexRow text-default bg-transparency'
                  (click)="operation({ target: 'freeze', type: node.origin['type'] }, node)"
                  [nzDisabled]="node.origin['organ_peoples'] != 0"
                  *ngIf="node.origin['type'] != 3"
                >
                  <i nz-icon nzIconfont='icon_freeze' *ngIf="node.origin['status'] == 2"></i>
                  <i nz-icon nzIconfont='icon_unfreeze' *ngIf="node.origin['status'] == 3"></i>
                  <div>{{ node.origin['status'] == 2 ? '冻结' : '启用' }}</div>
                </li>
              </ul>
            </nz-dropdown-menu>
          </div>
        </div>
      </ng-template>
    </nz-tree>
  </div>
</div>
